import { render, staticRenderFns } from "./NavSaveMore.vue?vue&type=template&id=0a75fd50&"
import script from "./NavSaveMore.vue?vue&type=script&lang=js&"
export * from "./NavSaveMore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports